import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "errors"]

  close() {
    this.element.remove()
  }

  onSuccess(event) {
    const data = event.detail[0]
    if (data.success) {
      const salespersonSelect = document.querySelector('select[name*="hollander_salesperson_id"]')
      if (salespersonSelect) {
        const newOption = new Option(data.salesperson.display_name, data.salesperson.id, true, true)
        salespersonSelect.add(newOption)
      }

      this.close()

      if (data.message) {
        const notification = document.createElement("div")
        notification.className = "fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50"
        notification.textContent = data.message
        document.body.appendChild(notification)
        setTimeout(() => notification.remove(), 3000)
      }
    } else {
      this.showErrors(data.errors)
    }
  }

  onError() {
    this.errorsTarget.innerHTML = '<div class="bg-red-50 border border-red-200 rounded-md p-4 mb-4"><p class="text-sm text-red-700">An error occurred. Please try again.</p></div>'
  }

  showErrors(errors) {
    let html = '<div class="bg-red-50 border border-red-200 rounded-md p-4 mb-4">'
    html += '<div class="flex"><div class="ml-3">'
    html += '<h3 class="text-sm font-medium text-red-800">There were errors with your submission:</h3>'
    html += '<div class="mt-2 text-sm text-red-700"><ul class="list-disc pl-5 space-y-1">'
    errors.forEach(error => { html += `<li>${error}</li>` })
    html += "</ul></div></div></div></div>"
    this.errorsTarget.innerHTML = html
  }
}
